import styled from 'styled-components';

export const CopyButtonContainer = styled.div<{show: boolean}>`
  display: flex;
  align-items: center;
  gap: var(--column-gap);
  align-self: flex-start;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity var(--fade-duration) ease-in-out;
  
  /* Remove bottom margin from JargonButton inside this container */
  button {
    margin-bottom: 0;
    align-self: initial; /* Reset align-self for buttons inside this container */
  }
`;

export const EnjoyText = styled.span<{show: boolean}>`
  font-size: 1rem;
  font-style: italic;
  color: var(--jargon-secondary);
  margin-left: 30px;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity var(--fade-duration) ease-in-out;
`;